import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e324927"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialogHeader" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blueBar" }, null, -1))
const _hoisted_3 = ["id"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "dialog-footer" }

import {
  computed,
  reactive,
  ref,
  watch,
} from 'vue';
import {transformI18n} from '@/langs/i18n';
import {userUpdate} from '@/api/user';
import {defaultRolesWithInstaller, defaultRoles} from '@/utils/defines';
import {debounce, isEmail, toTimeFormatFilter} from '@/utils';
import {agencyList} from '@/api/agency';
import {getCountryObj} from '@/utils/countryList';
import {useSettingStore} from '@/stores/setting';
import {ElMessage, FormInstance, FormRules} from 'element-plus';
import {useUserStore} from '@/stores/user';
import {useRouter} from 'vue-router';

type VoidNoop = (arg0?: Error) => void
interface stateType {
  userRole: string,
  email: string,
  country: string,
  phone: string,
  agencyId: string,
  lastLogin: string,
  creationTime: string,
  updateTime: string,
  level: number,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'personInfoDialog',
  props: {
  visible: {
    type: Boolean,
    default: false,
  },
},
  emits: ['update:visible', 'add', 'update'],
  setup(__props, { emit }) {

const props = __props;

const userStore = useUserStore();


const loading = ref(false);
const router = useRouter();

const agencyVal = computed(() => agencyObjData.value[form.agencyId]);
const agencyObjData = ref({});
const isSelfAgency = computed(() => userStore.userInfo?.agencyId === form.agencyId);
const isAdmin = computed(() => userStore.userInfo?.role === defaultRoles.admin.name);
const isAgency = computed(() => userStore.userInfo?.role === defaultRoles.agency.name);



const ruleFormRef = ref<FormInstance>();

const defaultCountryObj = computed(() => {
  const settingStore = useSettingStore();
  const local: string = settingStore.lang;
  let language = 'en';
  if (local === 'zh' || local === 'zh-cn') {
    language = 'zh';
  }
  return getCountryObj(language);
});

const isAgencyOrInstallerUserRole = computed(() => {
  const {
    userRole,
  } = form;
  return userRole === defaultRolesWithInstaller.agency.name
    || userRole === defaultRolesWithInstaller.installer.name;
});

const defaultForm = {
  userRole: '',
  email: '',
  country: '',
  phone: '',
  agencyId: '',
  lastLogin: '',
  creationTime: '',
  updateTime: '',
  level: undefined,
};

const form = reactive<stateType>({
  ...defaultForm,
});

const validateEmail = (rule: any, value: string, callback: VoidNoop) => {
  if (value === '') {
    callback(new Error(transformI18n('user.emailReg')));
    return;
  }
  if (!isEmail(value)) {
    callback(new Error(transformI18n('user.emailCorrectReg')));
    return;
  }
  callback();
};

const rules = computed(() => reactive<FormRules>({
  userRole: [{required: true, message: transformI18n('user.userRoleReg'), trigger: 'change'}],
  email: [{required: true, validator: validateEmail, trigger: 'change'}],
  country: [{required: true, message: transformI18n('user.countryReg'), trigger: 'change'}],
  agencyId: [{required: true, message: transformI18n('user.organizationReg'), trigger: 'change'}],
}));

const handlerClose = () => {
  updateVisible();
};

const updateVisible = () => {
  emit('update:visible', false);
};

watch(() => props.visible, (newValue) => {
  if (newValue) {
    const {
      email,
      country,
      phone,
      agencyId,
      role,
      lastLogin,
      createAt,
      updateAt,
      level,
    } = userStore.userInfo;
    let userRole = role;
    if (role === defaultRolesWithInstaller.agency.name) {
      if (level === defaultRolesWithInstaller.installer.installerLevel) {
        userRole = defaultRolesWithInstaller.installer.name;
      }
    }
    Object.assign(form, {
      userRole: userRole || '',
      email: email || '',
      country: country || '',
      phone: phone || '',
      agencyId: agencyId || '',
      lastLogin,
      creationTime: createAt,
      updateTime: updateAt,
    });
    if (isAgencyOrInstallerUserRole.value) {
      getAllAgencyList();
    }
    setTimeout(() => {
      ruleFormRef.value?.clearValidate();
    });
  }
});

const getAllAgencyList = async () => {
  try {
    const res = await agencyList({
      includeSelf: true,
    });
    agencyObjData.value = {};
    for (const row of res.data.rows) {
      agencyObjData.value[row._id] = {no: row.no, name: row.name};
    }
  } catch {
    // do nothing.
  }
};

const handleSure = debounce(() => {
  ruleFormRef.value?.validate((valid?: boolean) => {
    if (valid) {
      updateUser();
    }
  });
}, 500, true);

const updateUser = async () => {
  const id = userStore.userInfo?.id;
  const {
    country,
    phone,
  } = form;
  loading.value = true;
  try {
    await userUpdate({
      id: id || null,
      country: country || null,
      phone: phone || null,
    });
    ElMessage.success(transformI18n('common.editSuccess'));
    emit('update');
    updateVisible();
  } catch {
    // do nothing.
  } finally {
    loading.value = false;
  }
};

const toAgencyByNo = () => {
  handlerClose();
  router.push({
    path: '/agency',
    query: {agencyNo: agencyVal.value?.no},
  });
};

const toAgencyByName = () => {
  handlerClose();
  router.push({
    path: '/agency',
    query: {agencyName: agencyVal.value?.name},
  });
};

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": __props.visible,
    "onUpdate:visible": updateVisible,
    onClose: handlerClose
  }, {
    header: _withCtx(({titleId, titleClass}) => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("span", {
          id: titleId,
          class: _normalizeClass(titleClass)
        }, _toDisplayString(_unref(transformI18n)('user.personInfo')), 11, _hoisted_3)
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_6, [
        _createVNode(_component_el_button, { onClick: updateVisible }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(transformI18n)('common.cancel')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          loading: loading.value,
          type: "primary",
          onClick: _unref(handleSure)
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(transformI18n)('common.submit')), 1)
          ]),
          _: 1
        }, 8, ["loading", "onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref_key: "ruleFormRef",
        ref: ruleFormRef,
        model: form,
        rules: _unref(rules),
        size: "default",
        "label-position": "right",
        "label-width": "180px",
        style: {"width":"80%"}
      }, {
        default: _withCtx(() => [
          (_unref(isAdmin) || _unref(isAgency))
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                label: _unref(transformI18n)('user.userRole'),
                prop: "userRole"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_unref(transformI18n)(_unref(defaultRolesWithInstaller)[form.userRole]?.explain)), 1)
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          (_unref(isAgencyOrInstallerUserRole))
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 1,
                label: _unref(transformI18n)('user.organizationNo'),
                prop: "agencyId"
              }, {
                default: _withCtx(() => [
                  (_unref(isSelfAgency))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(agencyVal)?.no), 1))
                    : (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        class: "linkText",
                        onClick: toAgencyByNo,
                        onKeypress: toAgencyByNo
                      }, _toDisplayString(_unref(agencyVal)?.no), 33))
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          (_unref(isAgencyOrInstallerUserRole))
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 2,
                label: _unref(transformI18n)('user.organizationName'),
                prop: "agencyId"
              }, {
                default: _withCtx(() => [
                  (_unref(isSelfAgency))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref(agencyVal)?.name), 1))
                    : (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        class: "linkText",
                        onClick: toAgencyByName,
                        onKeypress: toAgencyByName
                      }, _toDisplayString(_unref(agencyVal)?.name), 33))
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          _createVNode(_component_el_form_item, {
            label: _unref(transformI18n)('user.email'),
            prop: "email"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(form.email), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _unref(transformI18n)('user.country'),
            prop: "country"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: form.country,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.country) = $event)),
                modelModifiers: { trim: true },
                clearable: "",
                filterable: "",
                style: {"width":"100%"},
                tabindex: "2",
                placeholder: _unref(transformI18n)('common.pleaseSelect')
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(defaultCountryObj), (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.alpha2,
                      label: item.name,
                      value: item.alpha2
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _unref(transformI18n)('user.phone'),
            prop: "phone"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: form.phone,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.phone) = $event)),
                modelModifiers: { trim: true },
                clearable: "",
                name: "phone",
                autocomplete: "on",
                type: "text",
                maxlength: "50",
                tabindex: "4"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _unref(transformI18n)('common.creationTime')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(toTimeFormatFilter)(form.creationTime)), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _unref(transformI18n)('user.lastLoginTime')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(toTimeFormatFilter)(form.lastLogin)), 1)
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})